module.exports = __webpack_public_path__ + "img/icon-project-launch.02f06a04.svg";